import React from "react"
import CloseModal from "../CloseModal"
import QRCode from "react-qr-code"
import { Button } from "../ui/button"
import { SvgCode, SvgShare } from "../icons/"
import { Textarea } from "../ui/textarea"
import { useToast } from "../../hooks/useToast"

interface Props {
  endpoint_slug: string
  shareModalOpen: any
  setShareModalOpen: any
  showWidget?: boolean
}

const ShareModal: React.FC<Props> = ({
  endpoint_slug,
  setShareModalOpen,
  shareModalOpen,
  showWidget = false,
}) => {

  const { toast } = useToast()
  const base = process.env.REACT_APP_BASE_URL

  const sendToClipboard = (stringToCopy: string) => {
    navigator.clipboard.writeText(stringToCopy)
    toast.success("Copied to clipboard")
  }

  const profilePageLink = `${base}/find-a-coach/${endpoint_slug}`

  const buttonSnippet = `<a href="${profilePageLink}" target="_blank" rel="noopener noreferrer"><svg xmlns="http://www.w3.org/2000/svg" width="226" height="50" fill="none" xmlns:v="https://vecta.io/nano"><rect x="1" y="1" width="224" height="48" rx="7" fill="#fcfcfc"/><path d="M21.104 30V18.8h5.104c2.608 0 3.84 1.232 3.84 2.976 0 1.248-.704 2.08-1.632 2.368v.032c1.088.336 1.872 1.28 1.872 2.672C30.288 28.8 28.8 30 26.08 30h-4.976zm4.768-9.28h-2.24v2.608h2.24c1.056 0 1.616-.464 1.616-1.296 0-.8-.576-1.312-1.616-1.312zm-.032 4.464h-2.208v2.896h2.192c1.216 0 1.872-.528 1.872-1.44 0-.928-.656-1.456-1.856-1.456zm10.058 5.008c-2.512 0-4.496-1.696-4.496-4.384 0-2.64 2.032-4.304 4.496-4.304 2.48 0 4.496 1.648 4.496 4.304 0 2.672-2 4.384-4.496 4.384zm0-1.984c1.2 0 2-.928 2-2.4 0-1.392-.816-2.32-2-2.32-1.2 0-2 .928-2 2.32 0 1.456.816 2.4 2 2.4zm9.953 1.984c-2.512 0-4.496-1.696-4.496-4.384 0-2.64 2.032-4.304 4.496-4.304 2.48 0 4.496 1.648 4.496 4.304 0 2.672-2 4.384-4.496 4.384zm0-1.984c1.2 0 2-.928 2-2.4 0-1.392-.816-2.32-2-2.32-1.2 0-2 .928-2 2.32 0 1.456.816 2.4 2 2.4zM57.372 30l-1.936-3.536-1.232 1.28V30h-2.4V18.48h2.4v6.4l2.88-3.168h2.928l-2.896 3.008L60.06 30h-2.688zm14.659 0l-1.472-5.232L69.087 30h-2.32l-2.64-8.288h2.416l1.536 5.424 1.472-5.424h2.096l1.488 5.392 1.52-5.392h2.32L74.351 30h-2.32zm6.008-9.504V18.48h2.448v2.016h-2.448zm0 9.504v-8.288h2.432V30h-2.432zm7.35.016c-1.52 0-2.416-.448-2.416-2.272v-4.256h-1.344v-1.776h1.344v-2.064h2.384v2.064h1.84v1.776h-1.84v3.696c0 .832.256.992.912.992h.928v1.808l-1.808.032zm5.691-4.432V30h-2.432V18.48h2.432v3.504.624c.528-.688 1.408-1.088 2.432-1.088 1.808 0 3.024 1.088 3.024 3.312V30h-2.432v-4.736c0-1.056-.544-1.664-1.456-1.664-.848 0-1.568.624-1.568 1.984z" fill="#0d0d0d"/><g clip-path="url(#A)"><g fill="#0d0d0d"><path d="M122.699 22.941v-6.695c0-.681-.545-1.246-1.207-1.246h-14.285c-.662 0-1.207.564-1.207 1.246v16.719c0 .681.545 1.246 1.207 1.246h14.285c.662 0 1.207-.564 1.207-1.246v-2.413c0-.019 0-.039.02-.058l5.177-7.143c.097-.136 0-.311-.156-.311h-4.944c-.058 0-.097-.039-.097-.097zM151.465 15c-5.235 0-9.342 4.223-9.342 9.615s4.107 9.615 9.342 9.615 9.342-4.224 9.342-9.615S156.701 15 151.465 15zm0 14.344c-2.588 0-4.476-1.985-4.476-4.73s1.888-4.729 4.476-4.729 4.477 1.985 4.477 4.729-1.869 4.73-4.477 4.73zm29.973-4.729c0-5.469-3.854-9.615-8.953-9.615-5.43 0-9.381 4.048-9.381 9.615 0 5.664 4.029 9.615 9.79 9.615 3.153 0 5.624-1.109 7.357-3.289.077-.097.058-.234-.059-.292l-3.561-2.121c-.078-.039-.156-.039-.215.019-.856.779-2.102 1.246-3.444 1.246-2.414 0-3.99-.954-4.652-2.822l-.156-.409h12.943c.097 0 .175-.078.195-.175.097-.564.136-1.168.136-1.771zm-13.332-1.654l.097-.389c.545-2.063 2.063-3.192 4.243-3.192 2.102 0 3.601 1.168 4.146 3.192l.097.389h-8.583zm33.962 1.654c0-5.469-3.853-9.615-8.952-9.615-5.431 0-9.382 4.048-9.382 9.615 0 5.664 4.029 9.615 9.79 9.615 3.153 0 5.625-1.109 7.357-3.289.078-.097.059-.234-.058-.292l-3.562-2.121c-.078-.039-.156-.039-.214.019-.856.779-2.102 1.246-3.445 1.246-2.413 0-3.97-.954-4.651-2.822l-.156-.409h12.943c.097 0 .175-.078.194-.175a10.46 10.46 0 0 0 .136-1.771zm-13.332-1.654l.098-.389c.545-2.063 2.063-3.192 4.243-3.192 2.102 0 3.6 1.168 4.145 3.192l.098.389h-8.584zm-48.54-7.766c0-.117-.078-.195-.194-.195h-1.09-.837-11.736a.21.21 0 0 0-.195.195v4.477c0 .117.078.195.195.195h7.726c.078 0 .117.097.078.156l-7.96 10.86c-.019.039-.039.078-.039.117v2.997c0 .117.078.195.195.195h1.965 11.698a.21.21 0 0 0 .194-.195v-4.476c0-.117-.078-.195-.194-.195h-7.435c-.078 0-.117-.097-.078-.156l7.668-10.451c.02-.039.039-.078.039-.117v-3.406z"/></g><g fill="#000"><path d="M203.664 15.214h-.661v1.83h-.273v-1.83h-.662V15h1.577v.214h.019zm.643-.214l.661 1.674.682-1.674h.35v2.044h-.272v-.798l.019-.856-.681 1.654h-.195l-.662-1.654.02.856v.798h-.273V15h.351z"/></g></g><rect x="1" y="1" width="224" height="48" rx="7" stroke="#0d0d0d" stroke-width="2"/><defs><clipPath id="A"><path fill="#fff" transform="translate(106 15)" d="M0 0h100v20H0z"/></clipPath></defs></svg></a>`

  return (
    <>
      <div
        className="fixed top-0 left-0 w-screen h-screen flex items-center
                justify-center zoee-backdrop-filter md:z-[801] z-[1009]"
      >
        <div
          className="w-[800px] max-w-[90%] main-shadow rounded-[16px] pt-[76px] pb-[40px] mt-[90px]
                    px-[16px] md:px-[75px] max-h-[85vh] bg-white fixed flex flex-col items-start overflow-y-auto"
        >
          <CloseModal
            callback={() => setShareModalOpen(false)}
            styling="absolute top-[24px] right-[32px] flex items-center justify-center w-[32px] h-[32px] rounded-full bg-grayFlash"
          />
          <div className="flex w-full justify-center items-center mb-8">
            <h2 className="font-bold text-[20px] flex items-center">
              <SvgShare className="mr-2" /> Share Your Website
            </h2>
          </div>

          <div className="flex flex-col w-full justify-center items-center">
            <div className="h-auto max-w-[200px] w-full mb-8 mx-auto mt-8">
              <QRCode
                size={256}
                className="h-auto w-full"
                value={profilePageLink}
                viewBox={`0 0 256 256`}
              />
            </div>
            <div className="mb-6">
              <Button onClick={() => sendToClipboard(profilePageLink)}>
                Copy URL
              </Button>
            </div>
          </div>
          {showWidget && (
            <>
              <div className="w-full border border-grayCloud mb-4"></div>
              <div className="flex w-full justify-center items-center mb-4">
                <h2 className="font-bold text-[20px] flex items-center">
                  <SvgCode className="mr-2" /> Embedded Zoee Widget
                </h2>
              </div>

              <div className="grid sm:grid-cols-2 w-full gap-2 mb-2">
                <div className="border border-dashed rounded-md border-input p-2 flex items-center justify-center">
                  <a
                    href={`${base}/find-a-coach/${endpoint_slug}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="226"
                      height="50"
                      fill="none"
                    >
                      <rect
                        width="224"
                        height="48"
                        x="1"
                        y="1"
                        fill="#fcfcfc"
                        rx="7"
                      ></rect>
                      <path
                        fill="#0d0d0d"
                        d="M21.104 30V18.8h5.104c2.608 0 3.84 1.232 3.84 2.976 0 1.248-.704 2.08-1.632 2.368v.032c1.088.336 1.872 1.28 1.872 2.672C30.288 28.8 28.8 30 26.08 30h-4.976zm4.768-9.28h-2.24v2.608h2.24c1.056 0 1.616-.464 1.616-1.296 0-.8-.576-1.312-1.616-1.312zm-.032 4.464h-2.208v2.896h2.192c1.216 0 1.872-.528 1.872-1.44 0-.928-.656-1.456-1.856-1.456zm10.058 5.008c-2.512 0-4.496-1.696-4.496-4.384 0-2.64 2.032-4.304 4.496-4.304 2.48 0 4.496 1.648 4.496 4.304 0 2.672-2 4.384-4.496 4.384zm0-1.984c1.2 0 2-.928 2-2.4 0-1.392-.816-2.32-2-2.32-1.2 0-2 .928-2 2.32 0 1.456.816 2.4 2 2.4zm9.953 1.984c-2.512 0-4.496-1.696-4.496-4.384 0-2.64 2.032-4.304 4.496-4.304 2.48 0 4.496 1.648 4.496 4.304 0 2.672-2 4.384-4.496 4.384zm0-1.984c1.2 0 2-.928 2-2.4 0-1.392-.816-2.32-2-2.32-1.2 0-2 .928-2 2.32 0 1.456.816 2.4 2 2.4zM57.372 30l-1.936-3.536-1.232 1.28V30h-2.4V18.48h2.4v6.4l2.88-3.168h2.928l-2.896 3.008L60.06 30h-2.688zm14.659 0l-1.472-5.232L69.087 30h-2.32l-2.64-8.288h2.416l1.536 5.424 1.472-5.424h2.096l1.488 5.392 1.52-5.392h2.32L74.351 30h-2.32zm6.008-9.504V18.48h2.448v2.016h-2.448zm0 9.504v-8.288h2.432V30h-2.432zm7.35.016c-1.52 0-2.416-.448-2.416-2.272v-4.256h-1.344v-1.776h1.344v-2.064h2.384v2.064h1.84v1.776h-1.84v3.696c0 .832.256.992.912.992h.928v1.808l-1.808.032zm5.691-4.432V30h-2.432V18.48h2.432v4.128c.528-.688 1.408-1.088 2.432-1.088 1.808 0 3.024 1.088 3.024 3.312V30h-2.432v-4.736c0-1.056-.544-1.664-1.456-1.664-.848 0-1.568.624-1.568 1.984zM122.699 22.941v-6.695c0-.681-.545-1.246-1.207-1.246h-14.285c-.662 0-1.207.564-1.207 1.246v16.719c0 .681.545 1.246 1.207 1.246h14.285c.662 0 1.207-.564 1.207-1.246v-2.413c0-.019 0-.039.02-.058l5.177-7.143a.194.194 0 00-.156-.311h-4.944c-.058 0-.097-.039-.097-.097zM151.465 15c-5.235 0-9.342 4.223-9.342 9.615s4.107 9.615 9.342 9.615 9.342-4.224 9.342-9.615S156.701 15 151.465 15zm0 14.344c-2.588 0-4.476-1.985-4.476-4.73s1.888-4.729 4.476-4.729 4.477 1.985 4.477 4.729-1.869 4.73-4.477 4.73zm29.973-4.729c0-5.469-3.854-9.615-8.953-9.615-5.43 0-9.381 4.048-9.381 9.615 0 5.664 4.029 9.615 9.79 9.615 3.153 0 5.624-1.109 7.357-3.289.077-.097.058-.234-.059-.292l-3.561-2.121c-.078-.039-.156-.039-.215.019-.856.779-2.102 1.246-3.444 1.246-2.414 0-3.99-.954-4.652-2.822l-.156-.409h12.943c.097 0 .175-.078.195-.175.097-.564.136-1.168.136-1.771zm-13.332-1.654l.097-.389c.545-2.063 2.063-3.192 4.243-3.192 2.102 0 3.601 1.168 4.146 3.192l.097.389h-8.583zm33.962 1.654c0-5.469-3.853-9.615-8.952-9.615-5.431 0-9.382 4.048-9.382 9.615 0 5.664 4.029 9.615 9.79 9.615 3.153 0 5.625-1.109 7.357-3.289.078-.097.059-.234-.058-.292l-3.562-2.121c-.078-.039-.156-.039-.214.019-.856.779-2.102 1.246-3.445 1.246-2.413 0-3.97-.954-4.651-2.822l-.156-.409h12.943c.097 0 .175-.078.194-.175a10.46 10.46 0 00.136-1.771zm-13.332-1.654l.098-.389c.545-2.063 2.063-3.192 4.243-3.192 2.102 0 3.6 1.168 4.145 3.192l.098.389h-8.584zm-48.54-7.766c0-.117-.078-.195-.194-.195h-13.663a.21.21 0 00-.195.195v4.477c0 .117.078.195.195.195h7.726c.078 0 .117.097.078.156l-7.96 10.86c-.019.039-.039.078-.039.117v2.997c0 .117.078.195.195.195h13.663a.21.21 0 00.194-.195v-4.476c0-.117-.078-.195-.194-.195h-7.435c-.078 0-.117-.097-.078-.156l7.668-10.451a.27.27 0 00.039-.117v-3.406z"
                      ></path>
                      <path
                        fill="#000"
                        d="M203.664 15.214h-.661v1.83h-.273v-1.83h-.662V15h1.577v.214h.019zm.643-.214l.661 1.674.682-1.674h.35v2.044h-.272v-.798l.019-.856-.681 1.654h-.195l-.662-1.654.02.856v.798h-.273V15h.351z"
                      ></path>
                      <rect
                        width="224"
                        height="48"
                        x="1"
                        y="1"
                        stroke="#0d0d0d"
                        rx="7"
                      ></rect>
                      <defs>
                        <clipPath id="A">
                          <path
                            fill="#fff"
                            d="M0 0h100v20H0z"
                            transform="translate(106 15)"
                          ></path>
                        </clipPath>
                      </defs>
                    </svg>
                  </a>
                </div>
                <Textarea
                  value={buttonSnippet}
                  className="font-normal text-sm w-full resize-none"
                  readOnly
                  rows={10}
                  onFocus={(e) => e.target.select()}
                ></Textarea>
              </div>
              <div className="flex w-full justify-center items-center mt-4">
                <Button onClick={() => sendToClipboard(buttonSnippet)}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="w-4 h-4"
                  >
                    <path d="m18 16 4-4-4-4" />
                    <path d="m6 8-4 4 4 4" />
                    <path d="m14.5 4-5 16" />
                  </svg>
                  Copy Code
                </Button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default ShareModal